<template>
  <div>
    <div v-if="type === 1" class="s-list relative text-left">
      <ul
        v-if="lists && lists.length !== 0"
        class="s-list-content s-list-content-yellow text-left"
      >
        <li v-for="list in lists" :key="list.id" class="relative">
          <div
            class="cursor-pointer font-css"
            @click="
              link(
                {
                  type: 'info',
                  category: list.category_id,
                  id: list.id
                },
                'windowOpen'
              )
            "
          >
            <i class="s-line"></i>{{ list.title }}
          </div>

          <div class="absolute pin-t pin-l hover-title-css">
            {{ list.title }}
          </div>
        </li>
      </ul>
      <div v-else class="text-center no-data">暂无数据</div>
      <div
        class="more absolute"
        @click="
          link(
            {
              type: 'list',
              link: '/list',
              template: 'with-thumbnail',
              category: lists[0].category_id
            },
            'windowOpen'
          )
        "
      >
        更多 | MORE
      </div>
    </div>
    <div v-if="type === 2" class="relative fp-list">
      <ul v-if="lists && lists.length !== 0" class="il-list-content">
        <li v-for="list in lists.slice(0, 3)" :key="list.id" class="relative">
          <div
            class="cursor-pointer font-css"
            @click="
              link({
                type: 'info',
                category: list.category_id,
                id: list.id
              })
            "
          >
            <i class="s-line"></i>{{ list.title }}
            <span class="absolute">{{
              list.published_at ? dateFilter(list.published_at, '/', true) : ''
            }}</span>
          </div>
          <div class="absolute pin-t pin-l hover-title-css">
            {{ list.title }}
          </div>
        </li>
      </ul>
      <ul v-if="lists && lists.length !== 0" class="il-list-content">
        <li v-for="list in lists.slice(3, 6)" :key="list.id" class="relative">
          <div
            class="cursor-pointer font-css"
            @click="
              link({
                type: 'info',
                category: list.category_id,
                id: list.id
              })
            "
          >
            <i class="s-line"></i>{{ list.title }}
            <span class="absolute">{{
              list.published_at ? dateFilter(list.published_at, '/', true) : ''
            }}</span>
          </div>
          <div class="absolute pin-t pin-l hover-title-css">
            {{ list.title }}
          </div>
        </li>
      </ul>
      <ul v-if="lists && lists.length !== 0" class="il-list-content">
        <li v-for="list in lists.slice(6, 9)" :key="list.id" class="relative">
          <div
            class="cursor-pointer font-css"
            @click="
              link({
                type: 'info',
                category: list.category_id,
                id: list.id
              })
            "
          >
            <i class="s-line"></i>{{ list.title }}
            <span class="absolute">{{
              list.published_at ? dateFilter(list.published_at, '/', true) : ''
            }}</span>
          </div>
          <div class="absolute pin-t pin-l hover-title-css">
            {{ list.title }}
          </div>
        </li>
      </ul>
      <div v-else class="text-center no-data">暂无数据</div>
    </div>
  </div>
</template>

<script>
import link from '@/core/mixins/link'
import { getArticles } from '@/core/api'
import dateFilter from '@/core/mixins/dateFilter'
export default {
  name: 'home-list',
  props: {
    data: null,
    name: null,
    pageSize: null,
    type: null
  },
  mixins: [dateFilter, link],
  data() {
    return {
      lists: null
    }
  },
  computed: {},
  mounted: function() {
    this.getLists()
  },
  methods: {
    async getLists() {
      // 获取所有列表
      let data = {
        page: 1,
        pageSize: this.pageSize
      }
      let res = await getArticles(this.data, data)
      // console.log({ data, res }) // eslint-disable-line no-console
      if (res.status === 200) {
        this.lists = res.data.data.slice(0, this.pageSize)

        // if (this.type === 2) {
        //   console.log(this.type) // eslint-disable-line no-console
        // }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/css_base.scss';
.s-list {
  min-height: 200px;
  padding: 28px 20px 12px 28px;
  background-color: $c-transparent-6;
}

.s-list-content {
  color: $c-white;
  width: 65%;
  li {
    font-size: 14px;
    line-height: 30px;
  }
  li:last-child {
    margin-bottom: 10px;
  }
}

.more {
  bottom: 28px;
  right: 20px;
  z-index: 1;
}

// type=2 的样式
.fp-list {
  color: $c-white;
}
.fp-list-title {
  position: absolute;
  top: 20px;
  left: 0;
  width: 33px;
}

.il-list-line {
  top: 132px;
  height: 40px;
}
.il-list-content {
  text-align: left;
  width: 33.3%;
  display: inline-block;
  li {
    line-height: 2.5;
    width: 100%;
    display: inline-block;
    padding-right: 105px;
    .font-css,
    .hover-title-css {
      font-size: 14px;
    }
    span.absolute {
      right: 68px;
    }
    a {
      color: $c-font-main-light;
    }
  }
}

// 共通样式
.s-list-content li,
.il-list-content li,
.recent-announcement-list {
  cursor: pointer;
  &:hover {
    color: $c-tour-2 !important;
    a {
      color: $c-tour-2 !important;
    }
  }
  .font-css {
    overflow: hidden;
    -o-text-overflow: ellipsis; /* Opera 9-10 */
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .font-css:hover + .hover-title-css {
    transition: all 0.35s;
    -moz-transition: all 0.35s; /* Firefox 4 */
    -webkit-transition: all 0.35s; /* Safari 和 Chrome */
    -o-transition: all 0.35s; /* Opera */
    opacity: 1;
    z-index: 2;
  }
}
.s-list-content.s-list-content-yellow li {
  &:hover {
    color: $c-hover !important;
    a {
      color: $c-hover !important;
    }
  }
}
// 浮动框样式
.hover-title-css {
  opacity: 0;
  white-space: nowrap;
  padding: 4px 8px;
  line-height: 1;
  top: 30px;
  left: 10px;
  background-color: $c-list-bg;
  color: $c-breadcrumb-deep-font !important;
}
</style>
